<template>
  <div>
    <div class="dropdown">
      <!-- :style="source=='contract'?'position: absolute; left: 65%; top: 25px':source=='aml-overall' || source=='aml'?'position: absolute; right: 20px; top: 20px':is_cn_service_info?'position: absolute; left: 100%; white-space: nowrap; transform: translateX(-110%); top: 15px':'position: absolute; left: 65%; top: -45px'" -->
      <button class="btn btn-outline-secondary btn-sm"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="loading || sia_search_data_loading"
      >
        {{
          label == "" ? $t("message.download") : label
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading || sia_search_data_loading"
          style="
            border-top-width: 2px;
            border-top-color: #333 !important;
            top: 30px;
            right: -93px;
          "
        ></div>
        <div v-else>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 2C12.5523 2 13 2.44772 13 3L13 12.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L11 12.5858L11 3C11 2.44772 11.4477 2 12 2ZM3 14C3.55228 14 4 14.4477 4 15L4 19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20L19 20C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19L20 15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15L22 19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22L5 22C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19L2 15C2 14.4477 2.44772 14 3 14Z"
              fill="#333"
            />
          </svg>
        </div>
      </button>
      <div class="dropdown-menu" :class="source==='aml-overall' ? 'dropdown-menu-right' : ''" aria-labelledby="dropdownMenuButton">
        <a
          class="dropdown-item"
          v-if="source == 'main-service-cn'"
          @click="print('main-service-cn', true)"
          >{{ $t("message.find_partner.download_pdf") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'main-service-cn'"
          @click="print('main-service-cn', false)"
          >{{ $t("message.find_partner.download_pdf_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'main-service-cn' && (this.$route.name == 'find-partner-410' || this.$route.name == 'find-partner-410-admin')"
          @click="printExcel('main-service-cn', false)"
          >{{ $t("message.find_partner.download_excel") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'short-reference-search-cn'"
          @click="print('short-reference-search-cn', true)"
          >{{ $t("message.contracts.download_pdf") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'short-reference-search-cn'"
          @click="print('short-reference-search-cn', false)"
          >{{ $t("message.contracts.download_pdf_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'ktzh'"
          @click="print('proxy-ktzh', true)"
          >{{ $t("message.contracts.paper_copy_proxy_ktzh") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'ktzh'"
          @click="print('proxy-ktzh', false)"
          >{{ $t("message.contracts.paper_copy_proxy_ktzh_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'invoice'"
          @click="print('invoice', true)"
          >{{ $t("message.contracts.paper_copy_invoice") }}</a
        >
        <!-- <a
          class="dropdown-item"
          v-if="source == 'invoice'"
          @click="print('invoice', false)"
          >{{ $t("message.contracts.paper_copy_invoice_no_logo") }}</a
        > -->

        <a class="dropdown-item" v-if="source == 'cmr'" @click="print('cmr', true)">{{
          $t("message.contracts.paper_copy_cmr")
        }}</a>
        <!-- <a class="dropdown-item" v-if="source == 'cmr'" @click="print('cmr', false)">{{
          $t("message.contracts.paper_copy_cmr_no_logo")
        }}</a> -->

        <a
          class="dropdown-item"
          v-if="source == 'specification'"
          @click="print('specification', true)"
          >{{ $t("message.contracts.document_specification") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'specification'"
          @click="print('specification', false)"
          >{{ $t("message.contracts.document_specification_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'contract'"
          @click="print('contract', true)"
          >{{ $t("message.contracts.paper_copy_contract") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'contract'"
          @click="print('contract', false)"
          >{{ $t("message.contracts.paper_copy_contract_no_logo") }}</a
        >

        <a class="dropdown-item" v-if="source == 'contract'"
          ><input type="file" @change="attachPdfTemplate($event, index)"
        /></a>

        <a
          class="dropdown-item"
          v-if="source == 'transport_contract'"
          @click="print('transport_contract', true)"
          >{{ $t("message.contracts.paper_copy_transport_contract") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'transport_contract'"
          @click="print('transport_contract', false)"
          >{{ $t("message.contracts.paper_copy_transport_contract_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'packaging'"
          @click="print('packaging', true)"
          >{{ $t("message.contracts.paper_copy_packing") }}</a
        >
        <!-- <a
          class="dropdown-item"
          v-if="source == 'packaging'"
          @click="print('packaging', false)"
          >{{ $t("message.contracts.paper_copy_packing_no_logo") }}</a
        > -->

        <a
          class="dropdown-item"
          v-if="source == 'broker_contract'"
          @click="print('broker_contract', true)"
          >{{ $t("message.contracts.broker_contract") }}</a
        >
        <!-- <a
          class="dropdown-item"
          v-if="source == 'broker_contract'"
          @click="print('broker_contract', false)"
          >{{ $t("message.contracts.broker_contract_no_logo") }}</a
        > -->

        <a class="dropdown-item" v-if="source == 'aml'" @click="print('aml', true)">{{
          $t("message.contracts.pdf_aml")
        }}</a>
        <a class="dropdown-item" v-if="source == 'aml'" @click="print('aml', false)">{{
          $t("message.contracts.pdf_aml_no_logo")
        }}</a>

        <a
          class="dropdown-item"
          v-if="source == 'aml-overall'"
          @click="print('aml-overall', true)"
        >{{ $t("message.contracts.pdf_aml") }}</a>
        <a
          class="dropdown-item"
          v-if="source == 'aml-overall'"
          @click="print('aml-overall', false)"
        >{{ $t("message.contracts.pdf_aml_no_logo") }}</a>

        <a
          class="dropdown-item"
          v-if="source == 'liability-insurance'"
          @click="print('liability-insurance', true)"
          >{{ $t("message.contracts.pdf_liability_insurance") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'liability-insurance'"
          @click="print('liability-insurance', false)"
          >{{ $t("message.contracts.pdf_liability_insurance_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'insurance'"
          @click="print('insurance', true)"
          >{{ $t("message.contracts.pdf_insurance") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'insurance'"
          @click="print('insurance', false)"
          >{{ $t("message.contracts.pdf_insurance_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'company-info-service-cn'"
          @click="print('company-info-service-cn', true)"
          >{{ $t("message.find_partner.common_info_cn") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'company-info-service-cn'"
          @click="print('company-info-service-cn', false)"
          >{{ $t("message.find_partner.common_info_cn_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'court-info-service-cn'"
          @click="print('court-info-service-cn', true)"
          >{{ $t("message.find_partner.court_notice_info") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'court-info-service-cn'"
          @click="print('court-info-service-cn', false)"
          >{{ $t("message.find_partner.court_notice_info_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'corporate_news_service-cn'"
          @click="print('corporate_news_service-cn', true)"
          >{{ $t("message.find_partner.corporate_news_search") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'corporate_news_service-cn'"
          @click="print('corporate_news_service-cn', false)"
          >{{ $t("message.find_partner.corporate_news_search_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'enterprise-risk-scan-cn'"
          @click="print('enterprise-risk-scan-cn', true)"
          >{{ $t("message.contragent_search.enterprise_risk_scan") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'enterprise-risk-scan-cn'"
          @click="print('enterprise-risk-scan-cn', false)"
          >{{ $t("message.contragent_search.enterprise_risk_scan_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'enterprise-risk-scan-cn-full'"
          @click="print('enterprise-risk-scan-cn-full', true)"
          >{{ $t("message.contragent_search.enterprise_risk_scan") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'enterprise-risk-scan-cn-full'"
          @click="print('enterprise-risk-scan-cn-full', false)"
          >{{ $t("message.contragent_search.enterprise_risk_scan_no_logo") }}</a
        >

        <a
          class="dropdown-item"
          v-if="source == 'annual-report-cn'"
          @click="print('annual-report-cn', true)"
          >{{ $t("message.contragent_search.annual_report") }}</a
        >
        <a
          class="dropdown-item"
          v-if="source == 'annual-report-cn'"
          @click="print('annual-report-cn', false)"
          >{{ $t("message.contragent_search.annual_report_no_logo") }}</a
        >

        <!-- <a class="dropdown-item" v-if="source=='main-service-cn'" @click="print('main-service-cn')">{{$t('message.find_partner.main_service_cn')}}</a> -->
        <a
          class="dropdown-item"
          v-if="source == 'ktg_attorney'"
          @click="print('ktg_attorney', true)"
          >{{ $t("message.contracts.document_ktg_attorney") }}</a>
          <a
          class="dropdown-item"
          v-if="source == 'ktg_attorney'"
          @click="print('ktg_attorney', false)"
          >{{ $t("message.contracts.document_ktg_attorney_no_logo") }}</a>
      </div>
    </div>
    <div class="d-none">
      <div :id="'document-' + type" class="m-5">
        <!-- v-if="type!==''"-->
        <img
          v-if="type!=='short-reference-search-cn' && logo_required"
          style="display: block; margin: 0; height: 30px; width: 117px"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAAgCAMAAAAIToc+AAABoVBMVEUAAACAgIBAQEAzMzNVVVVJSUlAQEBVVVVNTU1GRkZVVVVOTk5JSUlQUFBLS0tHR0dRUVFKSkpOTk5JSUlPT09MTExKSkpQUFBOTk5MTExOTk5NTU1LS0tKSkpKSkpNTU1NTU1MTExLS0tOTk5LS0tNTU1MTExLS0tMTExLS0tNTU1LS0tMTExLS0tNTU1MTExLS0tLS0tLS0tNTU1MTExNTU1LS0tMTExNTU1LS0tNTU1LS0tNTU1LS0tMTExLS0tMTExLS0tNTU1MTExMTExLS0tNTU1MTExNTU1NTU1MTExMTExLS0tMTExMTExLS0tMTExLS0tNTU1MTExLS0tMTExMTExNTU1MTExNTU1MTExLS0tMTExMTExMTExMTExMTExMTExNTU1MTExNTU1MTExLS0tMTExMTExMTExMTExMTExNTU1MTExMTExMTExMTExLS0tMTExMTExMTExMTExNTU1MTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExNTU1MTExMTExMTExMTExMTEzaKJyjAAAAinRSTlMAAgQFBgcICQoLDA0OEBESFhgaHB0eHyAkJScoLDA0NTg5Ojs9P0BBQ0RJS01OUFFVWF9gZGdpa25wcXN0d3l6fH1+f4CEhYeIj5CUlZaXmJqfoKGmp6iqrK2vsLO1tri8vb6/wcLExcfIycrLzc/Y2t/i4+Tl5ufo6e7v8PHy8/T29/j5+vv8/f4UFW3pAAACi0lEQVR42uXXBVckORQF4Gzv4hQOgV3c3d3dfcdwH8ed4M791UPeodpOqidj6G0r/8peusK8bKp4sfuJTT31RekhZT3hkxm2B9GN2m3Mhx9dfsz9+951/8YdQOoAvmbft94B2HUcx9yz/sFZR6ylbnDODRriLnEbNcwFKXHp6XEe9QVNvQTAKg3BJelzcE4rawUwRHvZJXCb1SGu1n1uP+81dULSf0CPI5t8Nd84EMba9XQOmW59na8SvCS/59Q6top8ared9DgrvRsywjCvO8F0oQ35LZEqGjX1kruDTqcl1TrwJS+yec2uN1rpq6Dkm+NyJMr1upTQkKnTj8sslY6bqbTwyrcRpKNOrdMRtApgTlenYxecWYV0yunrf73CPOtDAOIkYejqhoAcSLfWm3CXy/Lv6EKWWxXdVZo6ywc8FhwrvzH52XCPeglt0aDbV1Onu54iqtT6PzVbgEvF1St12ni6+aOlU/JHQVHzydGhvQcueiHzTg1XF3tJSYk0unV1Ci9ZBRWqIi0bDT7/dZ/Y9fP/vSL7LpKVJ96M0K242xjSFx4qbjPHK37mivSLqdjg/kNcJjL3LMEp6Xq6MBcd9aDjcjrep3RlIeJ4Is+veBlQ6HHUWsqsygE9fRjAEmcsbhVAvnW9n7+Ks2UFpfgWfAJIVxX7mL3REYaWzgXV2yp9GxY65agvhCV8PoOFvurYtKA7WK/eCZYR+UyVFph5E7xpDl4kKVpZcMefzZxuvQ+TL0Y5UyZpG871TrmeDGS/LUZ6upKm2GI6T9309WrbPT7XRb/bd9J3awPu96nyr4Tx6zt9ry3k/nsTXhmLUheDMQ/TkwquGOEzmV7sfnUvm5lAX5/77kF/A/h/9G4TVwOCAAAAAElFTkSuQmCC"
        />

        <div v-if="!logo_required" style="display: block; margin: 0; height: 30px; width: 117px"></div>
        
        <proxy-ktzh v-if="type == 'proxy-ktzh'" :user_id="user_id"></proxy-ktzh>
        <pdf-invoice
          v-if="type == 'invoice'"
          :user_id="user_id"
          :doc_id="doc_id"
        ></pdf-invoice>

        <pdf-specification
          v-if="type == 'specification'"
          :user_id="user_id"
          :doc_id="doc_id"
        ></pdf-specification>

        <pdf-cmr
          v-if="type == 'cmr'"
          :user_id="user_id"
          :doc_id="doc_id"
        ></pdf-cmr>
        <pdf-contract
          v-if="type == 'contract'"
          :doc="document"
          :goods="goods"
          :user_id="user_id"
          :doc_id="doc_id"
          :doc_additional="doc_additional"
          :template="contract_template"
        >
        </pdf-contract>
        <pdf-transport-contract
          v-if="type == 'transport_contract'"
          :doc="document"
          :goods="goods"
          :user_id="user_id"
          :doc_id="doc_id"
          :doc_additional="doc_additional"
        ></pdf-transport-contract>
        <pdf-broker-contract
          v-if="type == 'broker_contract'"
          :doc="document"
          :goods="goods"
          :user_id="user_id"
          :doc_id="doc_id"
          :doc_additional="doc_additional"
        ></pdf-broker-contract>
        <pdf-packing
          v-if="type == 'packaging'"
          :user_id="user_id"
          :doc_id="doc_id"
        ></pdf-packing>
        <pdf-aml
          v-if="type == 'aml'"
          :doc="document"
          :doc_additional="doc_additional"
        >
        </pdf-aml>
        <pdf-aml-overall v-if="type == 'aml-overall'" :doc="document">
        </pdf-aml-overall>

        <pdf-liability-insurance
          v-if="type == 'liability-insurance'"
          :doc="document"
          :doc_id="doc_id"
          :doc_additional="doc_additional"
        ></pdf-liability-insurance>
        <pdf-insurance
          v-if="type == 'insurance'"
          :doc="document"
          :doc_id="doc_id"
          :doc_additional="doc_additional"
        ></pdf-insurance>
        <pdf-company-info-cn
          v-if="type == 'company-info-service-cn'"
          :doc="document"
          :doc_additional="doc_additional"
        ></pdf-company-info-cn>
        <pdf-court-info-cn
          v-if="type == 'court-info-service-cn'"
          :doc="document"
          :doc_additional="doc_additional"
        ></pdf-court-info-cn>
        <pdf-news-info-cn
          v-if="type == 'corporate_news_service-cn'"
          :doc="document"
          :doc_additional="doc_additional"
        ></pdf-news-info-cn>

        <pdf-annual-report-cn
          v-if="type == 'annual-report-cn'"
          :doc="document"
          :doc_additional="doc_additional"
        ></pdf-annual-report-cn>
        <pdf-enterprise-risk-scan-cn
          v-if="type == 'enterprise-risk-scan-cn'"
          :doc="document"
          :doc_additional="doc_additional"
        ></pdf-enterprise-risk-scan-cn>
        <pdf-enterprise-risk-scan-cn-full
          v-if="type == 'enterprise-risk-scan-cn-full'"
          :doc="document"
          :doc_additional="doc_additional"
        ></pdf-enterprise-risk-scan-cn-full>
        <pdf-main-service-cn
          v-if="type == 'main-service-cn'"
          :doc="document"
          :doc_additional="doc_additional"
          :goods="goods"
          :logo_required="logo_required"
        ></pdf-main-service-cn>
        <pdf-short-reference-search-cn
          v-if="type == 'short-reference-search-cn'"
          :doc="document"
          :doc_additional="doc_additional"
          :goods="goods"
          :logo_required="logo_required">
        </pdf-short-reference-search-cn>

        <pdf-ktg-attorney
          v-if="type == 'ktg_attorney'"
          :doc="document"
          :doc_id="doc_id"
          :doc_additional="doc_additional"
        ></pdf-ktg-attorney>
      </div>
    </div>
    <!-- <div class="d-none">
            <div id="document2" class="m-5">
                <img style="display: block;margin: 0; height: 30px; width: auto;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAAgCAMAAAAIToc+AAABoVBMVEUAAACAgIBAQEAzMzNVVVVJSUlAQEBVVVVNTU1GRkZVVVVOTk5JSUlQUFBLS0tHR0dRUVFKSkpOTk5JSUlPT09MTExKSkpQUFBOTk5MTExOTk5NTU1LS0tKSkpKSkpNTU1NTU1MTExLS0tOTk5LS0tNTU1MTExLS0tMTExLS0tNTU1LS0tMTExLS0tNTU1MTExLS0tLS0tLS0tNTU1MTExNTU1LS0tMTExNTU1LS0tNTU1LS0tNTU1LS0tMTExLS0tMTExLS0tNTU1MTExMTExLS0tNTU1MTExNTU1NTU1MTExMTExLS0tMTExMTExLS0tMTExLS0tNTU1MTExLS0tMTExMTExNTU1MTExNTU1MTExLS0tMTExMTExMTExMTExMTExMTExNTU1MTExNTU1MTExLS0tMTExMTExMTExMTExMTExNTU1MTExMTExMTExMTExLS0tMTExMTExMTExMTExNTU1MTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExNTU1MTExMTExMTExMTExMTEzaKJyjAAAAinRSTlMAAgQFBgcICQoLDA0OEBESFhgaHB0eHyAkJScoLDA0NTg5Ojs9P0BBQ0RJS01OUFFVWF9gZGdpa25wcXN0d3l6fH1+f4CEhYeIj5CUlZaXmJqfoKGmp6iqrK2vsLO1tri8vb6/wcLExcfIycrLzc/Y2t/i4+Tl5ufo6e7v8PHy8/T29/j5+vv8/f4UFW3pAAACi0lEQVR42uXXBVckORQF4Gzv4hQOgV3c3d3dfcdwH8ed4M791UPeodpOqidj6G0r/8peusK8bKp4sfuJTT31RekhZT3hkxm2B9GN2m3Mhx9dfsz9+951/8YdQOoAvmbft94B2HUcx9yz/sFZR6ylbnDODRriLnEbNcwFKXHp6XEe9QVNvQTAKg3BJelzcE4rawUwRHvZJXCb1SGu1n1uP+81dULSf0CPI5t8Nd84EMba9XQOmW59na8SvCS/59Q6top8ared9DgrvRsywjCvO8F0oQ35LZEqGjX1kruDTqcl1TrwJS+yec2uN1rpq6Dkm+NyJMr1upTQkKnTj8sslY6bqbTwyrcRpKNOrdMRtApgTlenYxecWYV0yunrf73CPOtDAOIkYejqhoAcSLfWm3CXy/Lv6EKWWxXdVZo6ywc8FhwrvzH52XCPeglt0aDbV1Onu54iqtT6PzVbgEvF1St12ni6+aOlU/JHQVHzydGhvQcueiHzTg1XF3tJSYk0unV1Ci9ZBRWqIi0bDT7/dZ/Y9fP/vSL7LpKVJ96M0K242xjSFx4qbjPHK37mivSLqdjg/kNcJjL3LMEp6Xq6MBcd9aDjcjrep3RlIeJ4Is+veBlQ6HHUWsqsygE9fRjAEmcsbhVAvnW9n7+Ks2UFpfgWfAJIVxX7mL3REYaWzgXV2yp9GxY65agvhCV8PoOFvurYtKA7WK/eCZYR+UyVFph5E7xpDl4kKVpZcMefzZxuvQ+TL0Y5UyZpG871TrmeDGS/LUZ6upKm2GI6T9309WrbPT7XRb/bd9J3awPu96nyr4Tx6zt9ry3k/nsTXhmLUheDMQ/TkwquGOEzmV7sfnUvm5lAX5/77kF/A/h/9G4TVwOCAAAAAElFTkSuQmCC">
                <pdf-packing :user_id=user_id :doc_id=doc_id></pdf-packing>
            </div>
        </div> -->
  </div>
</template>
<script>
import moment from "moment";
import html2pdf from "html2pdf.js";
import Header from "../../newhomepage/header.vue";
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
// var custom_font = require('../../vfs_fonts')
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var htmlToPdfmake = require("html-to-pdfmake");
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    user_id: {
      required: true,
    },
    source: {
      required: true,
      default: "ktzh",
    },
    doc_id: {
      required: true,
    },
    sia_search_data_loading: {
      default: false
    },
    analyse_id: {
      default: ""
    },
    document: {
      default: () => {
        return {};
      },
    },
    goods: {
      default: () => {
        return {};
      },
    },
    doc_additional: {
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      type: "",
      loading: false,
      contract_template: false,
      logo_required: true
    };
  },
  methods: {
    momentum(d) {
      return moment(d).format("D_MM_Y");
    },
    wrapChinese(str) {
      // const regex = /([\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]{1,100})/g;
      // const regex = /([\p{Unified_Ideograph}\u3006\u3007][\ufe00-\ufe0f\u{e0100}-\u{e01ef}]?)/gmu;
      // const regex = /([\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d])/gmu;
      const regex = /(\p{Script=Han}{1,100})/gu;

      return str.replace(regex, `<span class="cn-symbol">$1</span>`);
    },
    shouldIAddWhiteSpaces(string) {
      let array = string.split(" ");
      if (array.length == 1 && string.length > 10) return true;
      if (array.length > 1) {
        let decision = false;
        array.forEach((item) => {
          if (item.length > 10) decision = true;
        });
        return decision;
      }
      return false;
    },
    async makePdf(type) {
      console.log("makepdf called", this.type, type);
      // console.log(type, this.type)
      if (this.type == "" || type != this.type) {
        // alert('this case '+type+' '+this.type)
        return;
      }
       //console.log('type inside pdfmake', this.type, type)
      var element = document.getElementById("document-" + this.type);
      if (!element) {
        element = document.getElementById("document-");
      }
      console.log(element);
      //console.log('element', element)
      let images = element.querySelectorAll("img");
      await element.querySelectorAll(".table-responsive").forEach((res) => {
        res.classList.remove("table-responsive");
      });
      await element.querySelectorAll("table td").forEach((td) => {
        if (
          td.innerHTML == td.innerText &&
          this.shouldIAddWhiteSpaces(td.innerText)
        ) {
          td.innerText = td.innerText.split("").join("\u200b");
        }
      });
      await element.querySelectorAll("table img").forEach((res) => {
        res.classList.add("inline-image");
      });
      await element.querySelectorAll("table").forEach((res) => {
        res.style.breakWord = "break-all";
      });
      await images.forEach(async (image) => {
        if (image.src == "" || image.src == null) {
          // console.log('tainted')
          image.remove();
        } else {
          let downloadedImg = new Image();
          downloadedImg.crossOrigin = "Anonymous";
          downloadedImg.addEventListener("error", () => {
            image.remove();
          });
          await downloadedImg.addEventListener(
            "load",
            (di) => {
              let canvas = document.createElement("canvas");
              canvas.width = downloadedImg.width;
              canvas.height = downloadedImg.height;
              let ctx = canvas.getContext("2d");
              ctx.fillStyle = "#ffffff";
              ctx.fillRect(0, 0, downloadedImg.width, downloadedImg.height);
              ctx.drawImage(downloadedImg, 0, 0);
              let data = canvas.toDataURL("image/jpeg");
              // console.log(data)
              image.alt = data;
              image.src = data;
            },
            false,
          );
          downloadedImg.src = image.src;
        }
      });

      setTimeout(() => {
        let has_toc = false;
        let dom = htmlToPdfmake(
          this.wrapChinese(
            element.innerHTML
              .replaceAll("、", ", ")
              .replaceAll("。", ". ")
              .replaceAll("（", "(")
              .replaceAll("）", ")")
              .replaceAll(":*", ": *")
              .replaceAll("*;", "* ;"),
          ),
          {
            tableAutoSize: false,
            ignoreStyles: ["font-family"],

            customTag: function (params) {
              var ret = params.ret;
              var element = params.element;
              var parents = params.parents;
              switch (ret.nodeName) {
                case "ARTICLE": {
                  has_toc = true;
                  ret.style = ["invisible"];
                  ret.tocItem = true;
                  ret.text = element.title;

                  break;
                }
              }
              return ret;
            },

            nodeRule: (el) => {
              console.log(el);
              if (el.classList.includes("tocitem")) {
                has_toc = true;
                console.log("toco");
                return {
                  text: el.title,
                  style: "invisible",
                  tocItem: true,
                  margin: [0, 20, 0, 10],
                };
              }

              return undefined; // use pre-defined rules
            },
          },
        );

        if (has_toc) {
          var dom_index = 1;
          if (this.type == 'short-reference-search-cn')
            dom_index = 0;
          dom.push(dom[dom_index]);
          dom[dom_index] = {
            toc: {
              title: {
                text: this.$t("message.toc"),
                style: "html-header",
                margin: [0, 20, 0, 0],
              },
              textStyle: { bold: true, color: "#0000ff" },
              numberStyle: { bold: true, color: "#0000ff" },
            },
          };
          dom[dom_index]._margin = [0, 0, 0, 20];
        }
        console.log(dom);
        var dd = {
          footer: function (currentPage, pageCount) {
            return {
              text: currentPage.toString(),
              alignment: "right",
              style: "normalText",
              margin: [0, 20, 50, 0],
            };
          },
          content: dom,
          styles: {
            "html-header": {
              fontSize: 18,
              bold: true,
            },
            invisible: {
              fontSize: 0,
              color: "white",
            },
            foldable: {
              wordBreak: "break-all",
              fontSize: 4,
            },
            "html-table": {
              width: "100%", // it won't work: all links will remain 'blue'
            },
            "html-image": {
              width: 50, // it won't work: all links will remain 'blue'
              maxWidth: 50,
            },
            "cn-symbol": {
              decoration: false,
              font: "cn",
              fontSize: 6,
            },
            "inline-image": {
              _width: 50,
              _maxWidth: 50,
            },
            noBorders: {
              border: [false, false],
            },
          },
          defaultStyle: {
            fontSize: 8,
            font: "Roboto",
          },
        };
        if (this.type !== "")
        {
          var fileName = this.type;
          if (this.type === 'main-service-cn') {
            fileName = this.$t("message.find_partner.pdf_file_name");
          } else if (this.type === 'short-reference-search-cn') {
            fileName = this.$t("message.find_partner.pdf_short_file_name");
          } else if (this.type === 'company-info-service-cn') {
            fileName = this.$t("message.find_partner.pdf_company_info_service_cn");
          }
          pdfMake.createPdf(dd).download(fileName + ".pdf");
        }
        setTimeout(() => {
          this.loading = false;
          this.$root.$emit("pdf-generation-complete");
        }, 1000);
        // this.type = ''
      }, 2000);
    },
    print(type, logo_required = true) {
      console.log("print called", type);
      console.log("logo_required", logo_required);
      // alert(type)
      // this.makePdf(type)
      // return
      this.loading = true;
      this.type = type;
      this.logo_required = logo_required;
      // if(type=='specification'){
      //     this.makePdf(type)
      // }
      if (type == "enterprise-risk-scan-cn") {
        setTimeout(() => {
          this.printAnnual("aml");
        }, 1000);
      }
      if (type == "annual-report-cn") {
        setTimeout(() => {
          this.printAnnual("aml");
        }, 1000);
      }
      // if (type == 'aml') {
      //     setTimeout(()=>{
      //         this.printAML('aml');
      //     }, 1000)
      // }
    },
    printExcel(type, logo_required = true) {
      console.log("print called", type);
      console.log("logo_required", logo_required);
      console.log("analyse_id", this.analyse_id);
      var locale = this.$i18n.locale;
      console.log("locale", locale);

      if (this.$route.name == 'find-partner-410' || this.$route.name == 'find-partner-410-admin') {
        axios.get(`${window.base}/report/ExcelPartnerSearchWithRankings?id=${this.analyse_id}&locale=${locale}`, {
          responseType: 'blob'
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${this.$t("message.find_partner.partner_search_excel_filename")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
          })
          .catch((error) => {
            console.error("Download failed:", error);
          });
      }
    },
    printAnnual(type) {
      // // this.makePdf(type)
      // return
      var element = document.getElementById("document");
      var opt = {
        margin: [0.2, 0.1, 0.2, 0.1],
        filename: "Document_" + this.type + ".pdf",
        enableLinks: true,
        //pagebreak:    { mode: 'css', avoid: 'p' },
        pagebreak: { mode: ["avoid-all", "css"] },
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 4 },
        jsPDF: { unit: "in", format: "a3", orientation: "portrait" },
      };
      window.scrollTo(0, 0);
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          //print current pdf width & height to consol
          //var imgData = signature.toDataURL('image/png');
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            //if(type=='cmr')
            // pdf.addImage(imgData, 'PNG', 12, pdf.internal.pageSize.getHeight()-40)
            //else
            //pdf.addImage(imgData, 'PNG', 0.59, pdf.internal.pageSize.getHeight()-1.37)
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            //divided by 2 to go center
            // if(type=='cmr')
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-24, pdf.internal.pageSize.getHeight()-30);
            // else
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-1.18, pdf.internal.pageSize.getHeight()-0.59);
          }
        })
        .save();
      this.$root.$emit("aml-search-print-aml");
    },
    printAML(type) {
      // // this.makePdf(type)
      // return
      var element = document.getElementById("document");
      var opt = {
        margin: [0.2, 0.1, 0.2, 0.1],
        filename: "Document_" + this.type + ".pdf",
        enableLinks: true,
        //pagebreak:    { mode: 'css', avoid: 'p' },
        pagebreak: { mode: ["avoid-all", "css"] },
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      window.scrollTo(0, 0);
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          //print current pdf width & height to consol
          //var imgData = signature.toDataURL('image/png');
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            //if(type=='cmr')
            // pdf.addImage(imgData, 'PNG', 12, pdf.internal.pageSize.getHeight()-40)
            //else
            //pdf.addImage(imgData, 'PNG', 0.59, pdf.internal.pageSize.getHeight()-1.37)
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            //divided by 2 to go center
            // if(type=='cmr')
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-24, pdf.internal.pageSize.getHeight()-30);
            // else
            //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-1.18, pdf.internal.pageSize.getHeight()-0.59);
          }
        })
        .save();
      this.$root.$emit("aml-search-print-aml");
    },
    printPacking(type) {
      // this.makePdf(type)
      // return
      this.loading = true;
      this.type = type;
      var element = document.getElementById("document2");
      var opt = {
        margin: [1, 4, 1, 1],
        filename: "Document_" + this.type + ".pdf",
        enableLinks: false,
        pagebreak: { mode: "avoid-all" },
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      this.loading = false;
      this.type = "";
    },
    attachPdfTemplate(event, index) {
      if (typeof event.target.files[0] !== "undefined") {
        // console.log('contract template file');
        //console.log(event.target.files[0])
        var reader = new FileReader();

        reader.onload = (res) => {
          this.contract_template = res.target.result;
          this.loading = true;
          this.type = "contract";
        };
        reader.readAsText(event.target.files[0]);

        // reader.onload = function(event) {
        //     this.contract_template = reader.result;
        //     console.log(reader.result);

        // }
        // setTimeout(() => {
        //         this.loading = true
        //         this.type = 'contract'
        //     }, 1000)
      }

      //this.files_att[index]=event.target.files[0]
    },
    formatCnServicesDocumentName() {
      var docName = "";
      if (this.goods.length === 1)
        docName +=
          this.$t("message.find_partner.service_" + this.goods[0]) + "_";
      else docName += "Services_list_";
      if (this.doc_additional.keyWord)
        docName += this.doc_additional.keyWord + "_";
      if (this.goods.includes("886"))
        docName +=
          this.doc_additional.keyWord886 +
          "_" +
          this.doc_additional.provinceCode +
          "_" +
          this.doc_additional.cityCode +
          "_";

      docName += this.momentum(new Date());

      return docName;
    },
  },
  computed: {
    is_cn_service_info() {
      switch (this.source) {
        case "company-info-service-cn":
        case "court-info-service-cn":
        case "corporate_news_service-cn":
        case "enterprise-risk-scan-cn":
        case "annual-report-cn":
        case "main-service-cn":
        case "short-reference-search-cn":
          return true;
          break;
      }
      return false;
    },
  },
  beforeDestroy() {
    this.$root.$off("print-aml");
  },
  mounted() {
    this.$root.$on("print-pdf", ({ signature, type }) => {
      console.log("print-pdf called");
      this.makePdf(type);
      return;
      console.log("print-pdf");
      console.log(signature, type);
      console.log(this.type);
      window.scrollTo(0, 0);
      if (type == this.type) {
        var element = document.getElementById("document");
        var opt = {
          margin: [1, 4, 1, 1],
          filename: "Document_" + this.type + ".pdf",
          enableLinks: false,
          pagebreak: { mode: "avoid-all" },
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        };
        if (
          this.source == "aml" ||
          this.source == "aml-overall" ||
          this.source == "company-info-service-cn" ||
          this.source == "court-info-service-cn" ||
          this.source == "corporate_news_service-cn"
        ) {
          var opt = {
            margin: [0.2, 0.1, 0.2, 0.1],
            filename: "Document_" + this.type + ".pdf",
            enableLinks: true,
            //pagebreak:    { mode: 'css', avoid: 'p' },
            pagebreak: { mode: ["avoid-all", "css"] },
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
          };
        }
        if (this.source == "main-service-cn") {
          console.log("document");
          console.log(element);
          var opt = {
            margin: [0.2, 0.1, 0.2, 0.1],
            filename: this.formatCnServicesDocumentName() + ".pdf",
            enableLinks: false,
            //pagebreak:    { mode: 'css', avoid: 'p' },
            pagebreak: { mode: ["css", "avoid-all"] },
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
              scale: 1.5,
              dpi: 192,
              allowTaint: true,
              useCORS: true,
            },
            jsPDF: { unit: "in", format: "a3", orientation: "landscape" },
          };
        }
        if (this.source == "cmr" || this.source == "packaging") {
          opt = {
            margin: [0, 0, 0, 0],
            filename: "Document_" + this.type + ".pdf",
            enableLinks: false,
            // pagebreak:    { mode: 'avoid-all' },
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 3 },
            jsPDF: { unit: "mm", format: "a3", orientation: "portrait" },
          };
        }
        if (this.type == "liability-insurance") {
          opt = {
            margin: [10, 0, 15, 0],
            filename: "Document_" + this.type + ".pdf",
            enableLinks: false,
            pagebreak: { avoid: "tr", after: "section" },
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          };
        }
        if (
          this.source == "contract" ||
          this.type == "invoice" ||
          this.type == "transport_contract" ||
          this.type == "broker_contract"
        ) {
          opt = {
            margin: [0.5, 0.5, 1.5, 0.5],
            filename: "Document_" + this.type + ".pdf",
            enableLinks: false,
            // pagebreak: {mode: ['css', 'legacy']},
            pagebreak: { mode: ["avoid-all", "css", "legacy"] },
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
          };
        }

        if (this.type != "packaging" || this.type != "liability-insurance") {
          html2pdf()
            .from(element)
            .set(opt)
            .toPdf()
            .get("pdf")
            .then((pdf) => {
              var totalPages = pdf.internal.getNumberOfPages();
              //print current pdf width & height to consol
              if (signature !== "")
                var imgData = signature.toDataURL("image/png");
              for (var i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                if (signature !== "")
                  if (type == "cmr")
                    pdf.addImage(
                      imgData,
                      "PNG",
                      12,
                      pdf.internal.pageSize.getHeight() - 40,
                    );
                  else
                    pdf.addImage(
                      imgData,
                      "PNG",
                      0.59,
                      pdf.internal.pageSize.getHeight() - 1.37,
                    );
                pdf.setFontSize(10);
                pdf.setTextColor(150);
                //divided by 2 to go center
                // if(type!='cmr')
                // pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-24, pdf.internal.pageSize.getHeight()-30);
                // else
                if (type != "cmr")
                  pdf.text(
                    i + " / " + totalPages,
                    pdf.internal.pageSize.getWidth() - 1.18,
                    pdf.internal.pageSize.getHeight() - 0.59,
                  );
              }
              if (type == "liability-insurance") pdf.deletePage(totalPages);
              if (type == "cmr" && totalPages > 1) pdf.deletePage(totalPages);
            })
            .save();
        } else {
          html2pdf()
            .from(element)
            .set(opt)
            .toPdf()
            .get("pdf")
            .then((pdf) => {
              var totalPages = pdf.internal.getNumberOfPages();
              //print current pdf width & height to consol
              //var imgData = signature.toDataURL('image/png');
              for (var i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                //if(type=='cmr')
                // pdf.addImage(imgData, 'PNG', 12, pdf.internal.pageSize.getHeight()-40)
                //else
                //pdf.addImage(imgData, 'PNG', 0.59, pdf.internal.pageSize.getHeight()-1.37)
                pdf.setFontSize(10);
                pdf.setTextColor(150);
                //divided by 2 to go center
                // if(type=='cmr')
                //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-24, pdf.internal.pageSize.getHeight()-30);
                // else
                //     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-1.18, pdf.internal.pageSize.getHeight()-0.59);
              }
            })
            .save();
        }

        this.loading = false;
        this.type = "";
      }
    });
    if (this.goods.includes("410")) {
      this.type = "4-1-0";
    }
    this.$root.$on("pdf-generation-complete", () => {
      this.type = "";
      this.loading = false;
    });
    this.$root.$on("print-aml", (search, logo_required = true) => {
      // this.document = search;
      // setTimeout(()=>{
      this.type = "aml";
      this.logo_required = logo_required;
      this.document = search;
      this.makePdf("aml");
      // }, 100)
      return;
      //this.document = search;
      this.loading = true;
      console.log("doc additional");
      console.log(this.doc_additional);
      this.type = "aml";
      setTimeout(() => {
        this.printAML("aml");
      }, 1000);

      //this.$root.$emit('print-aml-form', search);
    });
  },
};
</script>
<style scoped>
.btn.btn-outline-primary.btn-sm {
  padding: 16px 24px;
  gap: 8px;
  height: 40px;

  /* neutral/30 */

  background: #797980;
  border-radius: 8px;
  border-color: #797980;
  display: flex;
  align-items: center;
  color: #fff;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  /* primary100 */

  color: #ffffff;
}
</style>
